<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.3438 0.34375C4.82981 0.34375 0.34375 4.82981 0.34375 10.3438C0.34375 15.8577 4.82981 20.3438 10.3438 20.3438C15.8577 20.3438 20.3438 15.8577 20.3438 10.3438C20.3438 4.82981 15.8577 0.34375 10.3438 0.34375ZM15.3952 5.79231L13.1413 11.4269C12.9866 11.8139 12.7548 12.1654 12.4601 12.4601C12.1654 12.7548 11.8139 12.9866 11.4269 13.1413L5.79231 15.3952C5.72241 15.4232 5.64584 15.43 5.57209 15.4149C5.49834 15.3998 5.43065 15.3633 5.37742 15.3101C5.32418 15.2568 5.28774 15.1892 5.27261 15.1154C5.25748 15.0417 5.26433 14.9651 5.29231 14.8952L7.54615 9.26058C7.70091 8.8736 7.93267 8.52209 8.22738 8.22738C8.52209 7.93267 8.8736 7.70091 9.26058 7.54615L14.8952 5.29231C14.9651 5.26433 15.0417 5.25748 15.1154 5.27261C15.1892 5.28774 15.2568 5.32418 15.3101 5.37742C15.3633 5.43065 15.3998 5.49834 15.4149 5.57209C15.43 5.64584 15.4232 5.72241 15.3952 5.79231Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgCompass',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>